import { Injectable } from '@angular/core';
import { IonModal } from '@ionic/angular/standalone';

import { DemoozHistoryService } from '@demooz/services';

@Injectable({
  providedIn: 'root'
})
export class DemoozModalService {

    constructor(
        private demoozHistoryService: DemoozHistoryService
    ) {}
    
    async open(modal: IonModal) {        
        const modalState = {
            modal : true,
            desc : 'fake state for modal'
        };
        this.demoozHistoryService.pushState(modalState, '');   
        await modal.present();     
    }
    
    async onDidDismiss($event: any) {        
        if (!$event.detail.data?.backButton && window.history.state.modal) {   
            this.demoozHistoryService.popState();
        }         
    }
    
}
